import * as React from "react";
import * as _ from "lodash";
import { DataGridContent } from "../../../Models";
import { DataGridReusable } from "./TableReusable";

export interface IExpandableDataGridProps {
    content: DataGridContent;
    showPagination: boolean;
    isSortable: boolean;
    filterable: boolean;
    defaultPageSize?: number;
    addSpareParts: boolean;
}

export default function ExpandableDataGrid(props: IExpandableDataGridProps) {
    return (
        <DataGridReusable
            defaultPageSize={
                props.defaultPageSize ? props.defaultPageSize : 150000
            }
            data={props.content.data}
            columns={props.content.columns}
            showPagination={props.showPagination}
            filterable={props.filterable}
            isSortable={props.isSortable}
            // SubComponent={subComponent}
        />
    );
}
